module.exports = __webpack_public_path__ + "img/menu.9d53d633.png";